export default "__VITE_ASSET__DnTJY53R__"